import { setQzSecurityKeys } from '@dme/ticket-print';
import configs from '../config';

let qzKeysInitialized = false;
let qzKeysLoading = false;

async function loadKeyFromPath(filePath) {
  try {
    const response = await fetch(filePath);
    if (!response.ok) throw new Error();
    return await response.text();
  } catch {
    return '';
  }
}

export async function initializeQzKeys() {
  if (qzKeysInitialized || qzKeysLoading) return qzKeysInitialized;

  qzKeysLoading = true;

  try {
    const certificatePath = configs.QZ_ENC_CERTIFICATE_KEY;
    const privateKeyPath = configs.QZ_ENC_PRIVATE_KEY;

    if (!certificatePath || !privateKeyPath) return false;

    const [certificate, privateKey] = await Promise.all([
      loadKeyFromPath(`${process.env.PUBLIC_URL}/${certificatePath}`),
      loadKeyFromPath(`${process.env.PUBLIC_URL}/${privateKeyPath}`),
    ]);

    if (certificate && privateKey) {
      setQzSecurityKeys({ certificate, privateKey });
      qzKeysInitialized = true;
    }

    return qzKeysInitialized;
  } finally {
    qzKeysLoading = false;
  }
}

export function parseLogoDimensions(value) {
  const defaultWidth = 384;
  const defaultHeight = 200;

  if (!value) {
    return {
      maxLogoWidth: defaultWidth,
      maxLogoHeight: defaultHeight,
    };
  }

  const [width, height] = value
    .toLowerCase()
    .split('x')
    .map(Number);

  if (
    !Number.isFinite(width)
    || !Number.isFinite(height)
    || width <= 0
    || height <= 0
  ) {
    return {
      maxLogoWidth: defaultWidth,
      maxLogoHeight: defaultHeight,
    };
  }

  return {
    maxLogoWidth: width,
    maxLogoHeight: height,
  };
}

export function isQzInitialized() {
  return qzKeysInitialized;
}

export const CRUMB_TYPE = {
  NAV: 'nav',
  SPORT: 'sport',
  CATEGORY: 'category',
  TOURNAMENT: 'tournament',
  DISPLAY: 'display',
};

export const ROUTES_THAT_DONT_CLEAR_CRUMBS = [
  'match',
  'paris',
];

export function voucherPredefinedAmounts(maxAmount, step) {
  const max = Number(maxAmount);
  const stepValue = Number(step);

  if (!max || !stepValue || stepValue <= 0) {
    return [];
  }

  // Calculate max multiplier to reach maxAmount
  const maxMultiplier = Math.floor(max / stepValue);

  // Generate exactly 7 multipliers distributed across the range:
  // First 6 multipliers: evenly distributed from 0 to maxMultiplier
  // Last multiplier: maxMultiplier (to reach maxAmount)
  const stepMultiplier = Math.ceil(maxMultiplier / 50);
  const multipliers = [
    Math.ceil(1 * stepMultiplier),
    Math.ceil(2 * stepMultiplier),
    Math.ceil(4 * stepMultiplier),
    Math.ceil(8 * stepMultiplier),
    Math.ceil(16 * stepMultiplier),
    Math.ceil(32 * stepMultiplier),
    maxMultiplier,
  ];

  // Remove duplicates and sort
  const uniqueMultipliers = [...new Set(multipliers)].sort((a, b) => a - b);

  return uniqueMultipliers.map((m) => m * stepValue);
}
